module.exports = __webpack_public_path__ + "85c21578e33d66f5d5128e3a9c0f2ec7.pdf";